import { render, staticRenderFns } from "./rank-xiyatu.vue?vue&type=template&id=9a3f743e&scoped=true"
import script from "./rank-xiyatu.vue?vue&type=script&lang=js"
export * from "./rank-xiyatu.vue?vue&type=script&lang=js"
import style0 from "./rank-xiyatu.vue?vue&type=style&index=0&id=9a3f743e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a3f743e",
  null
  
)

export default component.exports